import { createSlice } from '@reduxjs/toolkit'

const initialStateValue = {
gstinData:null
}

export const gstinData = createSlice({
  name: 'gstinData',
  initialState: initialStateValue,
  reducers: {
    setGstinData:(state,action)=>{
      state.gstinData = action.payload
    },
  },
})

export const { setGstinData} = gstinData.actions

export default gstinData.reducer
